var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraitement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Groupe_2892",
    "data-name": "Groupe 2892",
    width: 84.971,
    height: 84.971,
    viewBox: "0 0 84.971 84.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 68.594,
    height: 48.328,
    fill: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 42.485,
    cy: 42.485,
    r: 42.485,
    fill: "#b6bcb8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2461",
    "data-name": "Groupe 2461",
    transform: "translate(8.142 17.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2460",
    "data-name": "Groupe 2460",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_824",
    "data-name": "Trac\\xE9 824",
    d: "M25.935,388.892a5.2,5.2,0,0,1-3.241-1.119,8.27,8.27,0,0,0-10.243,0,5.249,5.249,0,0,1-6.481,0A8.251,8.251,0,0,0,.849,386a.849.849,0,0,1,0-1.7,9.955,9.955,0,0,1,6.178,2.146,3.539,3.539,0,0,0,4.368,0,9.969,9.969,0,0,1,12.356,0,3.538,3.538,0,0,0,4.367,0,9.985,9.985,0,0,1,10.793-1.017.849.849,0,1,1-.787,1.5,8.289,8.289,0,0,0-8.949.842,5.2,5.2,0,0,1-3.241,1.12",
    transform: "translate(0 -342.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_825",
    "data-name": "Trac\\xE9 825",
    d: "M441.321,388.892a5.2,5.2,0,0,1-3.241-1.119,8.42,8.42,0,0,0-8.5-1.061.849.849,0,0,1-.693-1.55,10.145,10.145,0,0,1,10.248,1.283,3.538,3.538,0,0,0,4.367,0,9.963,9.963,0,0,1,6.179-2.145.849.849,0,0,1,0,1.7,8.256,8.256,0,0,0-5.121,1.776,5.2,5.2,0,0,1-3.241,1.12",
    transform: "translate(-381.938 -342.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_826",
    "data-name": "Trac\\xE9 826",
    d: "M25.935,297.926a5.2,5.2,0,0,1-3.241-1.121,8.275,8.275,0,0,0-10.243,0,5.247,5.247,0,0,1-6.482,0A8.251,8.251,0,0,0,.849,295.03a.849.849,0,0,1,0-1.7,9.957,9.957,0,0,1,6.178,2.145,3.535,3.535,0,0,0,4.367,0,9.971,9.971,0,0,1,12.357,0,3.534,3.534,0,0,0,4.367,0,9.971,9.971,0,0,1,12.357,0,3.415,3.415,0,0,0,1.358.655.849.849,0,0,1-.389,1.653,5.113,5.113,0,0,1-2.026-.979,8.273,8.273,0,0,0-10.243,0,5.2,5.2,0,0,1-3.241,1.121",
    transform: "translate(0 -261.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_827",
    "data-name": "Trac\\xE9 827",
    d: "M414.932,297.926a5.2,5.2,0,0,1-3.241-1.121,8.275,8.275,0,0,0-10.242,0,5.088,5.088,0,0,1-1.537.839.849.849,0,0,1-.548-1.607,3.42,3.42,0,0,0,1.028-.561,9.971,9.971,0,0,1,12.357,0,3.534,3.534,0,0,0,4.367,0,9.96,9.96,0,0,1,6.179-2.145.849.849,0,0,1,0,1.7,8.258,8.258,0,0,0-5.122,1.775,5.2,5.2,0,0,1-3.241,1.121",
    transform: "translate(-355.549 -261.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_828",
    "data-name": "Trac\\xE9 828",
    d: "M9.211,206.952a5.2,5.2,0,0,1-3.24-1.119,8.252,8.252,0,0,0-5.122-1.777.849.849,0,1,1,0-1.7A9.955,9.955,0,0,1,7.027,204.5a3.538,3.538,0,0,0,4.368,0,9.81,9.81,0,0,1,1.2-.818.849.849,0,0,1,.848,1.471,8.1,8.1,0,0,0-.993.677,5.208,5.208,0,0,1-3.241,1.12",
    transform: "translate(0 -180.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_829",
    "data-name": "Trac\\xE9 829",
    d: "M231.8,206.952a5.2,5.2,0,0,1-3.241-1.119,8.27,8.27,0,0,0-10.243,0,5.248,5.248,0,0,1-6.481,0,8.271,8.271,0,0,0-10.243,0,5.248,5.248,0,0,1-6.481,0,8.094,8.094,0,0,0-1.273-.832.849.849,0,0,1,.792-1.5,9.871,9.871,0,0,1,1.538,1,3.538,3.538,0,0,0,4.367,0,9.969,9.969,0,0,1,12.357,0,3.538,3.538,0,0,0,4.368,0,9.969,9.969,0,0,1,12.356,0,3.536,3.536,0,0,0,4.367,0,9.963,9.963,0,0,1,6.179-2.145.849.849,0,1,1,0,1.7,8.257,8.257,0,0,0-5.122,1.776,5.2,5.2,0,0,1-3.241,1.12",
    transform: "translate(-172.415 -180.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_830",
    "data-name": "Trac\\xE9 830",
    d: "M463.657,18.206q-.289,0-.57-.025a5.694,5.694,0,0,1-4.5-2.952,6.155,6.155,0,0,1-.16-5.739L462.9.436a.883.883,0,0,1,1.522,0l4.47,9.055a6.156,6.156,0,0,1-.16,5.74,5.692,5.692,0,0,1-4.5,2.951c-.192.016-.382.025-.574.025m0-15.477-3.709,7.513a4.462,4.462,0,0,0,.118,4.158,4.017,4.017,0,0,0,3.169,2.09,5.161,5.161,0,0,0,.847,0,4.017,4.017,0,0,0,3.165-2.09,4.461,4.461,0,0,0,.119-4.158Z",
    transform: "translate(-408.156 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_831",
    "data-name": "Trac\\xE9 831",
    d: "M117.549,141.789c-.174,0-.347-.007-.517-.023a5.118,5.118,0,0,1-4.041-2.652,5.528,5.528,0,0,1-.144-5.153l3.94-7.98a.883.883,0,0,1,1.522,0l3.94,7.98a5.526,5.526,0,0,1-.144,5.153,5.118,5.118,0,0,1-4.042,2.652c-.168.016-.341.023-.515.023m0-13.515-3.178,6.438a3.831,3.831,0,0,0,.1,3.571,3.443,3.443,0,0,0,2.714,1.791,4.046,4.046,0,0,0,.723,0,3.443,3.443,0,0,0,2.716-1.791,3.83,3.83,0,0,0,.1-3.571Z",
    transform: "translate(-100.106 -111.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_832",
    "data-name": "Trac\\xE9 832",
    d: "M352.289,312.16q-.261,0-.517-.023a5.118,5.118,0,0,1-4.041-2.652,5.527,5.527,0,0,1-.143-5.153l3.94-7.98a.883.883,0,0,1,1.522,0l3.94,7.98a5.526,5.526,0,0,1-.144,5.153,5.117,5.117,0,0,1-4.042,2.652q-.254.024-.515.023m0-13.515-3.178,6.438a3.831,3.831,0,0,0,.1,3.571,3.442,3.442,0,0,0,2.714,1.791,4.068,4.068,0,0,0,.723,0,3.443,3.443,0,0,0,2.715-1.791,3.83,3.83,0,0,0,.1-3.571Z",
    transform: "translate(-309.394 -263.831)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraitement);
export default __webpack_public_path__ + "static/media/traitement.39bc9085e0428be7d2ed71b78bceecf3.svg";
export { ForwardRef as ReactComponent };